import React from "react";
import NumberFormat from "react-number-format";

const SalesStatCard = ({ label, value, isCurrency = false }) => (
  <div className="stat-card-minimal">
    <p className="stat-label-minimal">{label}</p>
    <p className="stat-value-minimal">
      {isCurrency ? (
        <NumberFormat
          thousandSeparator={true}
          prefix={"₦"}
          className="numeric"
          displayType={"text"}
          value={parseFloat(value).toFixed(2)}
        />
      ) : typeof value === "number" ? (
        value.toLocaleString()
      ) : (
        value
      )}
    </p>
  </div>
);

export default SalesStatCard;
